import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Plus, X } from "lucide-react";

const AVATARS = [
  "https://images.unsplash.com/photo-1769636929388-99eff95d3bf1?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "https://images.unsplash.com/photo-1576558656222-ba66febe3dec?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "https://images.unsplash.com/photo-1762522926157-bcc04bf0b10a?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
];

export default function Employees() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", email: "", availability: "Full-time", avatar_url: "" });

  async function load() {
    const { data } = await api.get("/employees");
    setItems(data);
  }
  useEffect(() => { load(); }, []);

  async function submit(e) {
    e.preventDefault();
    const payload = { ...form, email: form.email || null,
      avatar_url: form.avatar_url || AVATARS[items.length % AVATARS.length] };
    await api.post("/employees", payload);
    setOpen(false);
    setForm({ name: "", phone: "", email: "", availability: "Full-time", avatar_url: "" });
    load();
  }

  return (
    <div className="p-8 lg:p-10" data-testid="employees-page">
      <header className="mb-8 flex items-end justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-2">Team</div>
          <h1 className="font-display text-4xl font-semibold tracking-tight">Employees</h1>
        </div>
        <button onClick={() => setOpen(true)} data-testid="add-employee-btn"
          className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-sm px-3 py-2 rounded-md transition-colors">
          <Plus className="w-4 h-4"/> Add Cleaner
        </button>
      </header>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.length === 0 && (
          <div className="col-span-full bg-white border border-slate-200 rounded-md p-8 text-center text-slate-500" data-testid="employees-empty">
            No employees yet. Add your first cleaner.
          </div>
        )}
        {items.map((e, idx) => (
          <div key={e.id} data-testid={`employee-card-${e.id}`} className="bg-white border border-slate-200 rounded-md p-5 card-hover">
            <div className="flex items-center gap-3">
              <img src={e.avatar_url || AVATARS[idx % AVATARS.length]} alt={e.name} className="w-12 h-12 rounded-md object-cover bg-slate-100"/>
              <div>
                <div className="font-medium text-slate-900">{e.name}</div>
                <div className="text-xs text-slate-500">{e.availability}</div>
              </div>
            </div>
            <div className="mt-4 text-sm text-slate-600 space-y-1">
              {e.phone && <div>{e.phone}</div>}
              {e.email && <div>{e.email}</div>}
            </div>
          </div>
        ))}
      </div>

      {open && (
        <div className="fixed inset-0 bg-slate-900/40 z-50 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-md w-full max-w-md p-6" onClick={(ev) => ev.stopPropagation()} data-testid="add-employee-modal">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display text-xl font-semibold">New Cleaner</h3>
              <button onClick={() => setOpen(false)}><X className="w-4 h-4"/></button>
            </div>
            <form onSubmit={submit} className="space-y-3">
              <input required placeholder="Name" data-testid="employee-name"
                value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full px-3 py-2 rounded-md border border-slate-300 text-sm outline-none focus:border-blue-500"/>
              <input placeholder="Phone" data-testid="employee-phone"
                value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="w-full px-3 py-2 rounded-md border border-slate-300 text-sm outline-none focus:border-blue-500"/>
              <input placeholder="Email" type="email" data-testid="employee-email"
                value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full px-3 py-2 rounded-md border border-slate-300 text-sm outline-none focus:border-blue-500"/>
              <select data-testid="employee-availability"
                value={form.availability} onChange={(e) => setForm({ ...form, availability: e.target.value })}
                className="w-full px-3 py-2 rounded-md border border-slate-300 text-sm outline-none focus:border-blue-500">
                <option>Full-time</option><option>Part-time</option><option>Weekends</option><option>On-call</option>
              </select>
              <button type="submit" data-testid="employee-submit"
                className="w-full bg-slate-900 hover:bg-slate-800 text-white text-sm font-medium py-2.5 rounded-md transition-colors">
                Save Cleaner
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
